declare namespace $ {

	export class $mol_icon_language_markdown_outline extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=outline.view.tree.d.ts.map